// export const primarycolor = "#fb0000"
// export const primarycolor = "#6a1b9a";
// export const primarycolor = "#ffd102";


export const primarycolor = "#ffa500"